import {
  HOME_LOAN_VERTICAL_CARD,
  MEDICAL_LOANS_VERTICAL_CARD,
  PERSONAL_LOAN_VERTICAL_CARD,
  PERSONAL_LOAN_VERTICAL,
  SWIMMING_LOANS_VERTICAL_CARD,
  TRAVEL_LOANS_VERTICAL_CARD,
  WEDDING_LOANS_VERTICAL_CARD,
} from 'types/marketplaceTiles.constants';

const metadataMap = {
  TRAVEL: {
    text: 'Travel',
    cardName: TRAVEL_LOANS_VERTICAL_CARD,
    url: '/offers/personalLoanPrequal/form?loanAmount=2000&loanFor=VACATION',
    vertical: PERSONAL_LOAN_VERTICAL,
    location: 'offers-personal-loan',
  },
  HOME_IMPROVEMENT: {
    text: 'Home improvement',
    cardName: HOME_LOAN_VERTICAL_CARD,
    url: '/offers/personalLoanPrequal/form?loanAmount=2000&loanFor=HOME_IMPROVEMENT',
    vertical: PERSONAL_LOAN_VERTICAL,
    location: 'offers-personal-loan',
  },
  WEDDING: {
    text: 'Wedding',
    cardName: WEDDING_LOANS_VERTICAL_CARD,
    url: '/offers/personalLoanPrequal/form?loanAmount=2000&loanFor=OTHER',
    vertical: PERSONAL_LOAN_VERTICAL,
    location: 'offers-personal-loan',
  },
  MEDICAL: {
    text: 'Medical',
    cardName: MEDICAL_LOANS_VERTICAL_CARD,
    url: '/offers/personalLoanPrequal/form?loanAmount=2000&loanFor=OTHER',
    vertical: PERSONAL_LOAN_VERTICAL,
    location: 'offers-personal-loan',
  },
  SWIMMING_POOL: {
    text: 'Swimming Pool',
    cardName: SWIMMING_LOANS_VERTICAL_CARD,
    url: '/offers/personalLoanPrequal/form?loanAmount=2000&loanFor=MAJOR_PURCHASE',
    vertical: PERSONAL_LOAN_VERTICAL,
    location: 'offers-personal-loan',
  },
  OTHER: {
    text: 'Other',
    cardName: PERSONAL_LOAN_VERTICAL_CARD,
    url: '/offers/personalLoanPrequal/form?loanAmount=2000&loanFor=OTHER',
    vertical: PERSONAL_LOAN_VERTICAL,
    location: 'offers-personal-loan',
  },
};

export default metadataMap;
